import VouchersForm from './VouchersForm';

export default VouchersForm;


// WEBPACK FOOTER //
// ./src/scenes/VouchersGenerateRandom/VouchersForm/index.tsx